import { z } from 'zod'

/**
 * Standard schema for API responses that return only a message.
 * Ex: { "message": "Operation performed successfully" }
 */
export const messageResponseSchema = z.object({
  message: z.string(),
})

/**
 * Factory to create response schemas that wrap data within a 'data' object.
 * Ex: { "data": { ... } }
 *
 * @param schema Schema of the object within 'data'
 */
export function makeDataResponseSchema<T extends z.ZodTypeAny>(schema: T) {
  return z.object({
    data: schema,
  })
}

/**
 * Base schema for the pagination/totalizador meta returned by listing endpoints.
 * Ex: { "records_total": 25, "page": 1, "limit": 15, ... }
 */
export const baseMetaSchema = z.object({
  records_total: z.number().optional(),
  all: z.boolean().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
  page: z.number().optional(),
})

export type BaseMeta = z.infer<typeof baseMetaSchema>

/**
 * Factory to create response schemas that include both data and a meta totalizador.
 * Ex: { "data": [...], "meta": { "records_total": 25 } }
 *
 * @param schema Schema of the object within 'data'
 */
export function makeDataMetaResponseSchema<T extends z.ZodTypeAny>(schema: T) {
  return z.object({
    data: schema,
    meta: baseMetaSchema,
  })
}
